(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ticketgames/ticket-utility/assets/javascripts/utils/result-dialog.js') >= 0) return;  svs.modules.push('/components/ticketgames/ticket-utility/assets/javascripts/utils/result-dialog.js');
"use strict";

const getReceiversThanksNote = async () => {
  try {
    const resp = await svs.tur.usersettings.get({
      key: 'receivers'
    });
    const receivers = (resp === null || resp === void 0 ? void 0 : resp.value) || [];
    if (receivers !== null && receivers !== void 0 && receivers.length) {
      const lastReceiverIndex = receivers.length - 1;
      const receiversText = receivers.reduce((text, name, i) => {
        if (i === 0) {
          return name;
        }
        return "".concat(text).concat(i === lastReceiverIndex ? ' och ' : ', ').concat(name);
      }, '');
      return "Men ".concat(receiversText, " tackar f\xF6r ditt st\xF6d genom Gr\xE4sroten.");
    }
  } catch (_unused) {}
  return '';
};
const resultDialogNormal = async _ref => {
  let wonAmount = _ref.wonAmount,
    onClose = _ref.onClose,
    onPlayAgain = _ref.onPlayAgain,
    _ref$hasNextVoucher = _ref.hasNextVoucher,
    hasNextVoucher = _ref$hasNextVoucher === void 0 ? false : _ref$hasNextVoucher,
    _ref$hasUnscratchedTi = _ref.hasUnscratchedTicket,
    hasUnscratchedTicket = _ref$hasUnscratchedTi === void 0 ? false : _ref$hasUnscratchedTi,
    _ref$isTicketOpen = _ref.isTicketOpen,
    isTicketOpen = _ref$isTicketOpen === void 0 ? true : _ref$isTicketOpen;
  const currencyFormatter = svs.ticketgames.ticketUtility.utils.currencyFormatter;
  let buttonTitle;
  const messages = [];
  const winAmount = currencyFormatter(wonAmount.value);
  const isWinning = winAmount > 0;
  if (isWinning) {
    messages.push({
      type: svs.ui.dialog.message.TEXT,
      text: "Du vann <b>".concat(svs.utils.format.Currency(winAmount), " kr.</b>"),
      align: svs.ui.dialog.message.align.CENTER
    });
    if (winAmount >= 1000000) {
      messages.push({
        type: svs.ui.dialog.message.TEXT,
        text: 'Vill du ha bankrådgivning?',
        align: svs.ui.dialog.message.align.CENTER
      });
      messages.push({
        type: svs.ui.dialog.message.TEXT,
        text: 'Vänligen kontakta Svenska Spel för förmedling av denna tjänst, <a href="tel:0770-11 11 11">0770-11 11 11</a>',
        align: svs.ui.dialog.message.align.CENTER
      });
    } else {
      messages.push({
        type: svs.ui.dialog.message.TEXT,
        text: 'Vinsten har satts in på ditt spelkonto.',
        align: svs.ui.dialog.message.align.CENTER
      });
    }
  } else {
    const receiversThanksNote = await getReceiversThanksNote();
    if (receiversThanksNote) {
      messages.push({
        type: svs.ui.dialog.message.TEXT,
        text: receiversThanksNote,
        align: svs.ui.dialog.message.align.CENTER
      });
    } else {
      messages.push({
        type: svs.ui.dialog.message.TEXT,
        text: ' ',
        align: svs.ui.dialog.message.align.CENTER
      });
    }
  }
  switch (true) {
    case hasNextVoucher:
      buttonTitle = 'Skrapa nästa presentlott';
      break;
    case hasUnscratchedTicket:
      buttonTitle = 'Skrapa nästa lott';
      break;
    case isTicketOpen:
      buttonTitle = 'Spela igen';
      break;
    default:
      buttonTitle = 'Välj ny lott';
  }
  const dialog = new svs.ui.dialog.Confirm({
    icon: isWinning ? 'win' : 'loose',
    branding: svs.ui.dialog.branding.TUR,
    title: isWinning ? 'Grattis!' : 'Tyvärr ingen vinst denna gång',
    message: messages,
    allowDimmerClick: false,
    actions: [{
      title: 'Avsluta spel',
      callback: () => {
        onClose();
        dialog.close();
      }
    }, {
      title: buttonTitle,
      callback: () => {
        onPlayAgain && onPlayAgain();
        dialog.close();
      }
    }]
  });
  svs.ui.dialog.api.add(dialog);
};
const resultDialogDemo = _ref2 => {
  let wonAmount = _ref2.wonAmount,
    onClose = _ref2.onClose,
    onPlayAgain = _ref2.onPlayAgain;
  const currencyFormatter = svs.ticketgames.ticketUtility.utils.currencyFormatter;
  const messages = [];
  const winAmount = currencyFormatter(wonAmount.value);
  if (winAmount > 0) {
    messages.push({
      type: svs.ui.dialog.message.TEXT,
      text: "Om du hade spelat ett riktigt spel hade du vunnit <b>".concat(svs.utils.format.Currency(winAmount), " kr.</b>"),
      align: svs.ui.dialog.message.align.CENTER
    });
  }
  messages.push({
    type: svs.ui.dialog.message.TEXT,
    text: 'Vill du köpa ett spel för chans att vinna på riktigt?',
    align: svs.ui.dialog.message.align.CENTER
  });
  const dialog = new svs.ui.dialog.Confirm({
    icon: 'games',
    branding: svs.ui.dialog.branding.TUR,
    title: 'Du har spelat ett provspel',
    message: messages,
    allowDimmerClick: false,
    actions: [{
      title: 'Avsluta spel',
      callback: () => {
        onClose();
        dialog.close();
      }
    }, {
      title: 'Köp spel',
      callback: () => {
        onPlayAgain();
        dialog.close();
      }
    }]
  });
  svs.ui.dialog.api.add(dialog);
};
setGlobal('svs.ticketgames.ticketUtility.utils.resultDialog', {
  resultDialogNormal,
  resultDialogDemo
});

 })(window);